import { render, staticRenderFns } from "./PaymentResponsibilityModal.vue?vue&type=template&id=025cfe98&scoped=true"
import script from "./PaymentResponsibilityModal.vue?vue&type=script&lang=js"
export * from "./PaymentResponsibilityModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentResponsibilityModal.vue?vue&type=style&index=0&id=025cfe98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cfe98",
  null
  
)

export default component.exports